var map = {
	"./1909Forsythie_colored.jpg": 64,
	"./2096Ambrosia_colored.jpg": 65,
	"./ambrosia.jpg": 66,
	"./pollen2.png": 67,
	"./tinywow_2173Cocos nucifera_colored_55475306.jpg": 68,
	"./tinywow_2430AmbrosiaBlütemaleKopie_colored_55475373.jpg": 69,
	"./tinywow_2433AmbrosiaBlüteale_colored_55475405.jpg": 70,
	"./tinywow_2434AmbrosiapollenaufNarbe_colored_55475442.jpg": 71,
	"./tinywow_2435AmbrosiapollenaufNarbe_colored_55475512.jpg": 72,
	"./tinywow_2437AntherevonAmbrosiamitPollen_colored_55475543.jpg": 73,
	"./tinywow_2515Corylusavellana_colored_55475596.jpg": 74,
	"./tinywow_2582Salixsp_colored_55475635.jpg": 75,
	"./tinywow_2589Erle_colored_55475686.jpg": 76,
	"./tinywow_2590Alnus_colored_55475738.jpg": 77,
	"./tinywow_3012Fraxinus_colored_55475780.jpg": 78,
	"./tinywow_3021Platanegruppe_colored_55475819.jpg": 79,
	"./tinywow_3024Plataneeinzeln_colored_55475923.jpg": 80,
	"./tinywow_Artemisiavulgaris_colored_55476013.jpg": 81,
	"./tinywow_Betula3500x_colored_55476049.jpg": 82,
	"./tinywow_Oleaeuropaea1500x_colored_55476087.jpg": 83,
	"./tinywow_Phleumprat.2700_colored_55476120.jpg": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;